// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
    margin: 0;
    padding: 0;
    font-family: 'Nunito Sans', sans-serif;
    
}

.main {
    width: 100%;
    height: 100vh;
    
}

img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.content {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    display: flex;
    flex-direction:  column;
    justify-content: center;
    align-items: center;
    color: white;
    
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7); 
    /* background-color: #000000cc; */
    
}

.form-control {
    margin-top: 2%;
    
}

.btn-banner {
    margin: 8% 3% 5% 0;
    
}

.logomarca {
    
   width: 50%;
   margin-left: 25%;
   

}

.login1 {
    width: 100%;
    margin-bottom: 50px;
   
}

.form-signin {
    width: 400px;
    padding: 15px;
    margin: auto;
    color: #000000;
    font-size: medium;
    
   

    border: 2px solid rgb(0, 0, 0);
    border-radius: 30px;
    border-style: solid solid solid solid;
    border-width: 10px 5px 10px 5px;
    border-color: #006cb5 #fc8702 #006cb5 #fc8702;
    background-color: white;

}



.actions {
    height: 100px;
    width: auto;
    text-align: center;
}

.control-label {
    font-size: 10px;
}

.links {
    text-align: center;
    font-weight: bold;
  }
  
.links a {
    text-decoration: none;
  }

`, "",{"version":3,"sources":["webpack://./src/Pages/Usuarios/styles.css"],"names":[],"mappings":";AACA;IACI,SAAS;IACT,UAAU;IACV,sCAAsC;;AAE1C;;AAEA;IACI,WAAW;IACX,aAAa;;AAEjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,iCAAiC;;AAErC;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;;GAEG,UAAU;GACV,gBAAgB;;;AAGnB;;AAEA;IACI,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,cAAc;IACd,iBAAiB;;;;IAIjB,8BAA8B;IAC9B,mBAAmB;IACnB,qCAAqC;IACrC,+BAA+B;IAC/B,6CAA6C;IAC7C,uBAAuB;;AAE3B;;;;AAIA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;EACnB;;AAEF;IACI,qBAAqB;EACvB","sourcesContent":["\n* {\n    margin: 0;\n    padding: 0;\n    font-family: 'Nunito Sans', sans-serif;\n    \n}\n\n.main {\n    width: 100%;\n    height: 100vh;\n    \n}\n\nimg {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.content {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    display: flex;\n    flex-direction:  column;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    \n}\n\n.overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7); \n    /* background-color: #000000cc; */\n    \n}\n\n.form-control {\n    margin-top: 2%;\n    \n}\n\n.btn-banner {\n    margin: 8% 3% 5% 0;\n    \n}\n\n.logomarca {\n    \n   width: 50%;\n   margin-left: 25%;\n   \n\n}\n\n.login1 {\n    width: 100%;\n    margin-bottom: 50px;\n   \n}\n\n.form-signin {\n    width: 400px;\n    padding: 15px;\n    margin: auto;\n    color: #000000;\n    font-size: medium;\n    \n   \n\n    border: 2px solid rgb(0, 0, 0);\n    border-radius: 30px;\n    border-style: solid solid solid solid;\n    border-width: 10px 5px 10px 5px;\n    border-color: #006cb5 #fc8702 #006cb5 #fc8702;\n    background-color: white;\n\n}\n\n\n\n.actions {\n    height: 100px;\n    width: auto;\n    text-align: center;\n}\n\n.control-label {\n    font-size: 10px;\n}\n\n.links {\n    text-align: center;\n    font-weight: bold;\n  }\n  \n.links a {\n    text-decoration: none;\n  }\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
